import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { Button, IconButton, Menu, MenuItem, List, ListItem, ListItemText } from '@material-ui/core'
import { Card } from 'react-bootstrap'
import { FORM_PROCESO_CALADO } from '../../../../config/forms'
import { COLORES } from '../../../../config/colores'
import CloseIcon from '@material-ui/icons/Close'
import { ToastContainer, toast } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { consultaEstadoOcupacionCallesCalado, updateCalleCamionCalado, updateCerealCalleDeCalado } from '../../actions'

function DialogoEdicionCalleCamionView (props) {
  const { cea, handleClose, estadoCalles, change: formChange } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedCalle, setSelectedCalle] = useState(cea.calleDeCalado)
  const [init, setInit] = useState(true)
  const open = Boolean(anchorEl)

  useEffect(() => {
    const setUp = () => {
      const calleDeCalado = cea.calleDeCalado
      // consultaEstadoOcupacionCallesCalado()
      formChange('calle', calleDeCalado)
      setInit(false)
    }
    if (init) { setUp() }
  }, [cea, formChange, init])

  const handleClickListItem = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = (e, calle, cereal) => {
    const { change: formChange } = props

    const estadoCalle = estadoCalles && (estadoCalles.filas).filter((c) => c.calleDeCalado === calle)
    const estado = estadoCalle[0]

    if (cereal === cea.claveCereal || estado.ocupado === 0) {
      if (cereal !== cea.claveCereal) {
        props.updateCerealCalleDeCalado(calle, cea.claveCereal)
      }
      setSelectedCalle(calle)
      setAnchorEl(null)
      formChange('calle', calle)
    } else {
      toast.error('Debe seleccionar una calle con un cereal asignado')
    }
  }

  const handleSubmit = () => {
    const { calle } = props
    const numero = cea.cartaDePorteAutomotor
    const fecha = cea.fechaDeCalado
    props.updateCalleCamionCalado(numero, fecha, calle)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Card
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 0
        }}
      >
        <Card.Header style={{ width: '100%' }}>
          <IconButton
            onClick={handleClose}
            style={{ margin: '0', padding: '5px 0', float: 'right' }}
          >
            <CloseIcon style={{ color: COLORES.grey.dark }} />
          </IconButton>
          <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Seleccione una nueva calle</Card.Text>
        </Card.Header>
        <Card.Body>

          <List
            style={{
              width: '100px',
              border: '1px solid',
              borderRadius: '10px',
              padding: '1px 29px',
              borderColor: '#d9d9d9',
              margin: '22px',
              backgroundColor: '#f9f9f9'
            }}

            component='nav'
            aria-label='Device settings'
          >
            <ListItem
              style={{ padding: '0', width: '100%' }}
              button
              aria-label='condicion seleccionada'
              onClick={handleClickListItem}
            >
              <ListItemText
                style={{ margin: '5px', textAlign: 'center' }}
                primary={[selectedCalle]}
              />
            </ListItem>
            <Menu
              id='lock-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseMenu}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              {estadoCalles && estadoCalles.filas.map((estado) => (
                <MenuItem
                  key={estado.calleDeCalado}
                  value={estado.calleDeCalado}
                  selected={estado.calleDeCalado === selectedCalle}
                  onClick={(e) => handleMenuItemClick(e, estado.calleDeCalado, estado.cerealAsignado)}
                >
                  {estado.ocupado === 0 ? estado.calleDeCalado : `${estado.calleDeCalado} - ${estado.cerealAsignado}`}
                </MenuItem>
              ))
              }
            </Menu>
          </List>
        </Card.Body>

        <div style={{
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch'
        }}
        >

          <Button
            type=''
            variant='contained'
            color='primary'
            onClick={() => handleSubmit()}
          >
              Confirmar
          </Button>
        </div>
      </Card>
    </>
  )
}

const selector = formValueSelector(FORM_PROCESO_CALADO)
const mapStateToProps = state => {
  return {
    calle: selector(state, 'calle'),
    estadoCalles: state.calado.estadoOcupacionCallesCalado
  }
}

const mapActionsToProps = {
  consultaEstadoOcupacionCallesCalado,
  updateCalleCamionCalado,
  updateCerealCalleDeCalado
}

export default reduxForm({
  form: FORM_PROCESO_CALADO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})(connect(mapStateToProps, mapActionsToProps)(DialogoEdicionCalleCamionView))
